import { render, staticRenderFns } from "./SModalTeamRequestConfirmation.vue?vue&type=template&id=1c86d549&scoped=true"
import script from "./sModalTeamRequestConfirmation.ts?vue&type=script&lang=ts&external"
export * from "./sModalTeamRequestConfirmation.ts?vue&type=script&lang=ts&external"
import style0 from "./SModalTeamRequestConfirmation.vue?vue&type=style&index=0&id=1c86d549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86d549",
  null
  
)

export default component.exports